module.exports = __webpack_public_path__ + "static/barcelona_code_school_campus_-9-63e7bb0628903d800a2bea46455b4adc.jpg";